export const datePickerStrings = {
  months: [
    'Januar',
    'Februar',
    'Marts',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'December',
  ],

  shortMonths: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],

  days: [
    'Søndag',
    'Mandag',
    'Tirsdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    'Lørdag',
  ],

  shortDays: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],

  goToToday: 'Gå til i dag',
  prevMonthAriaLabel: 'Gå til tidligere måned',
  nextMonthAriaLabel: 'Gå til næste måned',
  prevYearAriaLabel: 'Gå til tidligere år',
  nextYearAriaLabel: 'Gå til næste år',

  isRequiredErrorMessage: 'Feltet er påkrævet.',

  invalidInputErrorMessage: 'Ugyldigt format.',
};
